// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"JH-z","carouselContainer":"KH-z"};